  var players = {},
      playersMob = {},
      mobileslider = false,
      youapiinited = false,
      armodels = {};

  window.Shopify.loadFeatures([
    {
      name: 'model-viewer-ui',
      version: '1.0',
      onLoad: setupModelViewerUi
    }
  ]);
  function setupModelViewerUi(){
    $('body').find('model-viewer').each(function(){
      if(!$(this).closest('.notstarted').length){
        var i = $(this).closest('[data-slick-index]').length ? $(this).closest('[data-slick-index]').attr('data-slick-index') : '';
        armodels[i+$(this).attr('data-model-id')] = new Shopify.ModelViewerUI($(this)[0]);
        i == '' && armodels[i+$(this).attr('data-model-id')].play();
      }
    })
  }

  window.addEventListener('DOMContentLoaded', function() {
    $('[data-item-type]').length && initPrGalItemType();
    $('.notstarted').length && $('.notstarted').on('click', function(e){
      $(this).unbind('click');
      $(this).removeClass('notstarted');
    })
  });
  window.addEventListener('resize', function(){
    if($(window).width() < 576){
      mediaresizetomobile($('.mediaholder'));
      mediaresizetomobile($('.product-images-static'));
    }
    else{
      if(mobileslider){
        $('.tt-mobile-product-slider').find('video').each(function(){
          $(this)[0].pause();
        })
        stopYouVideos(playersMob);
      }
      $('[data-item-type]').length && getMediaGalleryItem($('[data-item-type]').first().closest('ul').find('.zoomGalleryActive'));
    }
  });
  window.addEventListener("mobile-slider-initialized", function(e){
    mobileslider = e.detail;
    if(mobileslider.find('.pt-product-media-external').length == 0 || !youapiinited) return false;
    collectPlayersMob(mobileslider);
  });
  function mediaresizetomobile($obj){
    if(!$obj.length) return false;
    $obj.find('video').each(function(){
      $(this)[0].pause();
    })
    stopYouVideos(players);
  }

  var tag = document.createElement('script');
  tag.src = "https://www.youtube.com/iframe_api";
  var firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  function onYouTubeIframeAPIReady() {
    collectPlayersDesk($('.mediaholder'));
    collectPlayersDesk($('.product-images-static'));
    youapiinited = true;
    mobileslider && collectPlayersMob(mobileslider);
  }
  function collectPlayersDesk($obj){
    if(!$obj.length) return false;
    $obj.find('.pt-product-media-external').each(function(){
      var $this = $(this),
          videoId = $this.attr('data-video-id');
      players[videoId] = new YT.Player($this.find('iframe')[0], {videoId: videoId});
    });
  }
  function collectPlayersMob($obj){
    $obj.find('.pt-product-media-external').each(function(){
      var $this = $(this),
          videoId = $this.attr('data-video-id'),
          i = $this.parent().attr('data-slick-index');
      playersMob[i+videoId] = new YT.Player($this.find('iframe')[0], {videoId: videoId});
    });
    $obj.on('beforeChange', function(event, slick, currentSlide, nextSlide){
      if(currentSlide == nextSlide) return true;
      var p = $(this).find('[data-slick-index="'+currentSlide+'"]'),
          v = false;

      v = p.find('.pt-product-media-external');
      if(v.length){
        var videoId = v.attr('data-video-id');
        playersMob[currentSlide+videoId].pauseVideo();
      }
      v = p.find('.pt-product-media-internal');
      if(v.length){
        v.find('video')[0].pause();
      }
    });
    $obj.on('afterChange', function(event, slick, currentSlide){
      var $this = $(this);

      var p = $this.find('[data-slick-index="'+currentSlide+'"]'),
          v = false;

      v = p.find('.pt-product-media-external');
      if(v.length){
        var videoId = v.attr('data-video-id');
        playersMob[currentSlide+videoId].playVideo();
      }
      v = p.find('.pt-product-media-internal');
      if(v.length){
        v.find('video')[0].play();
      }
      v = p.find('.pt-product-media-model');
      if(v.length && v.find('model-viewer').attr('reveal') != "auto"){
        armodels[currentSlide+v.find('model-viewer').attr('data-model-id')].play();
      }
    });
  }
  function initPrGalItemType(){
    $('[data-item-type]').click(function(e){
      getMediaGalleryItem($(this));
    })
  }

  /**/

  function getMediaGalleryItem($this){
    if(!$this.attr('data-item-type')) return false;
    if($this.attr('data-item-type') == 'image'){
      //$(".zoom-product").attr('src', $this.attr('data-image')).attr('data-zoom-image', $this.attr('data-zoom-image'));
      showMediaHolderOnProductPage(false)
      return true;
    }
    showMediaHolderOnProductPage(true, $this.attr('data-target'));
  }
  function showMediaHolderOnProductPage(val, attr){
    val = val || false;
    var $mh = $('.mediaholder'),
        $mhall = $mh.find('[data-target-id]'),
        $mhcur = $mh.find('[data-target-id='+attr+']');

    $mhall.length && $mhall.hide();
    $mh.find('video').each(function(){
      $(this)[0].pause();
    })

    stopYouVideos(players);

    if(val){
      $('.mediaimageholder').hide();
      $mh.show();
      $mhcur.show();

      $mhcur.find('video').length && $mhcur.find('video')[0].play();

      var y = $mhcur.find('iframe');
      if(y.length){
        var videoId = $mhcur.attr('data-video-id');
        players[videoId].playVideo();
      }
    }
    else{
      $('.mediaimageholder').show();
      $mh.hide();
    }
  }
  function stopYouVideos(players){
    if(Object.keys(players).length === 0) return false;
    Object.keys(players).forEach(function(key) {
      if (typeof players[key].pauseVideo === "function") { 
        players[key].pauseVideo();
      }
    });
  }
  /* arrows for big image in gallery */
  window.addEventListener("desktop-slider-initialized", function(e){
    var $this = e.detail;
    if(!$('#custom-product-item').length) return false;
    var l = $this.find('.slick-slide').length-1;
    $('#custom-product-item').addClass('tt-show');
    $('#custom-product-item').find('.slick-next').on('click',function(e){
      var c = Number($this.find('.zoomGalleryActive').parent().attr('data-slick-index')) + 1;
      c = c > l ? 0 : c;
      $this.find('[data-slick-index="'+c+'"] a').trigger('click');
    });
    $('#custom-product-item').find('.slick-prev').on('click',function(e){
      var c = Number($this.find('.zoomGalleryActive').parent().attr('data-slick-index')) - 1;
      c = c <= -1 ? l : c;
      $this.find('[data-slick-index="'+c+'"] a').trigger('click');
    });
  });